import {Image, Text, View} from '@react-pdf/renderer';
import styles from '../styles';
import {fixRtlNumberStart} from '../utils/formatData';

export default function CadastreReportsSection({
  farmName,
  ownerName,
  farmArea,
  cultivatedArea,
  farmImage = '',
}: {
  farmName: string;
  ownerName: string;
  farmArea: string;
  cultivatedArea: string;
  farmImage: string;
}) {
  return (
    <View wrap={false} style={styles.section}>
      <View
        style={{
          display: 'flex',
          flexDirection: 'row-reverse',
          textAlign: 'right',
          alignItems: 'center',
          margin: '12 15 0 15',
        }}
      >
        <Text
          style={{
            fontSize: 12,
            fontWeight: 500,
          }}
        >
          گزارش های حد نگاری
        </Text>
        <Text style={{opacity: 0.7, marginHorizontal: 4}}>
          (گزارش غیر رسمی)
        </Text>
      </View>
      <View style={styles.sectionCard}>
        <View style={styles.farmInfoCard}>
          <View style={styles.farmInfoPhoto}>
            <View style={styles.farmPhotoFrame}>
              <Image
                source={farmImage}
                style={{width: '100%', height: '100%'}}
              />
            </View>
          </View>
          <View style={styles.farmInfoData}>
            <Text style={{fontSize: 14, marginBottom: 20}}>{farmName}</Text>

            <View
              style={{
                display: 'flex',
                flexDirection: 'row-reverse',
                fontWeight: 400,
              }}
            >
              <View style={{flex: 1}}>
                <Text style={{opacity: '0.8'}}>نام مالک مزرعه</Text>
              </View>
              <View style={{flex: 1}}>
                <Text>{ownerName}</Text>
              </View>
            </View>

            <View
              style={{
                display: 'flex',
                flexDirection: 'row-reverse',
                marginVertical: 16,
              }}
            >
              <View style={{flex: 1}}>
                <Text style={{opacity: '0.8'}}>مساحت مزرعه</Text>
              </View>
              <View style={{flex: 1}}>
                <Text>{fixRtlNumberStart(farmArea)}</Text>
              </View>
            </View>

            <View style={{display: 'flex', flexDirection: 'row-reverse'}}>
              <View style={{flex: 1}}>
                <Text style={{opacity: '0.8'}}>مساحت کشت شده</Text>
              </View>
              <View style={{flex: 1}}>
                <Text>{fixRtlNumberStart(cultivatedArea)}</Text>
              </View>
            </View>
          </View>
        </View>
      </View>
    </View>
  );
}
